// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__127Gx","content":"styles_content__2bZUC"};